import { observer } from 'mobx-react-lite'; //
import { withDefaultProps } from 'react-default-props-context';
import { ExplanationT } from 'src/api/types/ExplanationT';
import { ForwardArrowIcon } from 'src/frames/icons/ForwardArrowIcon';
import { cn } from 'src/frames/utils/cn';
import './GoToNextExplanationButton.scss';

type PropsT = {
  nextExplanationPageIdx: number;
  className?: any;
};

type DefaultPropsT = {
  goToExplanationPage: (explanationPageIdx: number) => void;
  riskfactors: ExplanationT[];
};

export const GoToNextExplanationButton = observer(
  withDefaultProps<PropsT, DefaultPropsT>((props: PropsT & DefaultPropsT) => {
    return (
      <div className={cn('GoToNextExplanationButton', props.className)}>
        <button
          onClick={() =>
            props.goToExplanationPage(props.nextExplanationPageIdx)
          }
        >
          <ForwardArrowIcon />
        </button>
      </div>
    );
  })
);
